import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "sfx-separator__span"
}

import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSeparator',
  props: {
  icon: String,

  dimmed: {
    type: Boolean,
    default: false,
  },

  textWhite: {
    type: Boolean,
    default: false,
  },

  clickable: {
    type: Boolean,
    default: false,
  },

  iconDisabled: {
    type: Boolean,
    default: false,
  },

  marginNone: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`sfx-separator ${props.dimmed ? 'sfx-separator__dimmed' : undefined}`)
  }, [
    (!(Boolean(props.icon) || Boolean(_ctx.$slots.default)))
      ? (_openBlock(), _createBlock(_component_q_separator, {
          key: 0,
          inset: "",
          class: _normalizeClass(["sfx-separator__first", `${props.marginNone ? 'q-mx-none' : undefined}`])
        }, null, 8, ["class"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_q_separator, {
            inset: "",
            class: "sfx-separator__first"
          }),
          _createElementVNode("span", {
            class: _normalizeClass(["sfx-separator__second", props.textWhite ? 'text-white' : undefined])
          }, [
            (props.icon && !props.clickable)
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  name: props.icon,
                  size: "24px"
                }, null, 8, ["name"]))
              : (props.icon && props.clickable)
                ? (_openBlock(), _createBlock(SfxBtnIcon, {
                    key: 1,
                    icon: props.icon,
                    size: "16px",
                    disable: props.iconDisabled,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
                  }, null, 8, ["icon", "disable"]))
                : _createCommentVNode("", true),
            (Boolean(props.icon) && Boolean(_ctx.$slots.default))
              ? (_openBlock(), _createElementBlock("span", _hoisted_1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ], 2),
          _createVNode(_component_q_separator, {
            inset: "",
            class: "sfx-separator__third"
          })
        ], 64))
  ], 2))
}
}

})